import { render, staticRenderFns } from "./ModalRemind.vue?vue&type=template&id=29a84031&scoped=true&"
import script from "./ModalRemind.vue?vue&type=script&lang=js&"
export * from "./ModalRemind.vue?vue&type=script&lang=js&"
import style0 from "./ModalRemind.vue?vue&type=style&index=0&id=29a84031&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a84031",
  null
  
)

export default component.exports